module.exports = __webpack_public_path__ + "static/media/bg_default.c528c227.mp3";